import { render, staticRenderFns } from "./AssignTableGroups.vue?vue&type=template&id=cdb51d64&scoped=true&"
import script from "./AssignTableGroups.vue?vue&type=script&lang=ts&"
export * from "./AssignTableGroups.vue?vue&type=script&lang=ts&"
import style0 from "./AssignTableGroups.vue?vue&type=style&index=0&id=cdb51d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb51d64",
  null
  
)

export default component.exports